export const cpaMixin = {
  computed: {
    isCpaUser() {
      return (user) => user && user.role === 'CpaRole';
    },
  },
};

export default {cpaMixin};
